import PropTypes from 'prop-types';

import { Pill, PillIcon } from './styles';

const Pills = ({
  children,
  backgroundColor = '',
  textColor = '',
  pillIcon = null,
  className = '',
}) => {
  return (
    <Pill
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      className={className}
    >
      <>
        {pillIcon && <PillIcon src={pillIcon} alt="" />}
        {children}
      </>
    </Pill>
  );
};

Pills.propTypes = {
  children: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  pillIcon: PropTypes.shape(),
  className: PropTypes.string,
};

export default Pills;
